// TS types
import { ICommonStore } from '@redux/Common/interfaces';
import { INormalStore } from '@redux/Normal/interfaces';
import { scrollToRef, IOnSubmit, IValidateItem } from '@redux/common';
// Redux
import { store } from '@redux/store';
// api
import getEnvConfig from '@api/config';
import { fetchProductOrderValidity } from '@libs/apiCall';
// common function
import {
    formatProductDetailOrder,
    formatPassengerURL,
    openMemberLightBox,
    manageSessionStorage,
    parseApiResponse,
} from '@libs/core';
// plugin
import dayjs from 'dayjs';
import { t } from 'i18next';
// redux actions
import {
    setCalendarErrorMsg,
    setSessionErrorMsg,
    setTicketErrorMsg,
    setScrollTo,
    setSubmitWatcher,
    setIsSubmitSuccess,
} from '@redux/Normal/actions';
import { setVerificationStatus } from '@redux/Common/actions';

const onSubmit: IOnSubmit = async (type) => {
    const dispatch = store.dispatch;
    const allStates = store.getState();
    const {
        ticketNum,
        NowListData,
        DetailData,
        pickCalendar,
        pickSession,
        submitWatcher,
    }: INormalStore = allStates.Normal;
    const hasCalendar = NowListData?.ExpectedUseDay;
    const hasSession = DetailData?.Sessions;
    const submitDate = hasCalendar ? pickCalendar : dayjs().format('YYYY-MM-DD'); // 若非需選擇的日期的票券，則送當日日期

    const {
        ETID,
        isLogin,
        isErpOrder,
        ListData: { AdvanceTime },
        ProductDescKey
    }: ICommonStore = allStates.Common;

    switch (type) {
        case 'checkData':
            dispatch(setSubmitWatcher(!submitWatcher));

            //檢查月曆
            const checkCalendar = () => {
                if (!hasCalendar) return true;
                if (pickCalendar) return true;
                dispatch(setCalendarErrorMsg(t('noTHSR.onsubmit.selectDepartureDate')));
                return false;
            };

            //檢查場次
            const checkSession = () => {
                if (!hasSession) return true;
                if (pickSession) return true;
                dispatch(setSessionErrorMsg(t('noTHSR.onsubmit.selectSessionTime')));
                return false;
            };

            //檢查票種
            const checkTicketNum = () => {
                let status = false;
                Object.keys(ticketNum).forEach((itemSeq) => {
                    if (ticketNum[itemSeq] > 0) {
                        status = true;
                    }
                });
                if (!status) {
                    dispatch(setTicketErrorMsg(t('noTHSR.onsubmit.selectTicketTypeQuantity')));
                }
                return status;
            };

            if (AdvanceTime.length > 0) return;

            let calendarStatus = checkCalendar();
            let sessionStatus = checkSession();
            let ticketNumStatus = checkTicketNum();
            let apiData: IValidateItem | undefined;

            if (!calendarStatus) {
                dispatch(setScrollTo(scrollToRef.calender));
            } else if (!sessionStatus) {
                dispatch(setScrollTo(scrollToRef.session));
            } else if (!ticketNumStatus) {
                dispatch(setScrollTo(scrollToRef.ticket));
            }

            if (calendarStatus && sessionStatus && ticketNumStatus) {
                // 打驗證API確認當下時間產品上下限數量是否正確
                let order = formatProductDetailOrder(ticketNum);
                const checkValidate: IValidateItem = await parseApiResponse(() =>
                    fetchProductOrderValidity(ETID, order, submitDate)
                );

                apiData = checkValidate;
                dispatch(setVerificationStatus(checkValidate));
                if (checkValidate.IsSuccess) {
                    return {
                        selectChecked: true,
                        apiChecked: checkValidate,
                    };
                }
            }
            return { selectChecked: false, apiChecked: apiData ? apiData : {} };
        case 'redirect':
            const submitURL = getEnvConfig().normal.submitURL;
            let paramURL = formatPassengerURL({
                ETID,
                ticketNum,
                pickCalendar: submitDate,
                hasCalendar,
                pickSession: pickSession ? pickSession : '',
                ProductDescKey
            });

            /**
             *   最終導頁網址(確認是否為IT本地開發，IT本地網域不同)&光箱關閉事件
             *   IT本地&F2E本地在判斷環境上不相同(意謂IT本地在process.env.SERVER !== dev)
             *   https://udeveloper.liontravel.com:44369/passenger${paramURL}
             **/
            const finalUrl =
                window.location.hostname === 'udeveloper.liontravel.com'
                    ? `${window.location.origin}/order/passenger${paramURL}`
                    : `${submitURL}${paramURL}`;
            console.log('paramURL', finalUrl);
            const closeMemberFuc = () => {
                console.log('Close memberLightBox');
                dispatch(setIsSubmitSuccess(false));
            };
            //儲存IT認證參數
            manageSessionStorage('save', 'OrderProcess', 'FromDetail');

            // 確認登入狀態，未登入的話呼叫會員光箱
            if (isLogin) {
                window.location.href = finalUrl;
            } else {
                if (process.env.SERVER === 'dev' || isErpOrder) {
                    // 本機(沒有辦法呼叫會員光箱)或有電話單直接跳轉
                    window.location.href = finalUrl;
                } else {
                    // IT本地、測試&正式機(沒電話單情況)呼叫會員光箱跳轉
                    // 將 關閉送出按鈕Loading的事件 放進取消光箱
                    openMemberLightBox(finalUrl, closeMemberFuc);
                }
            }
            break;
    }
};

export default onSubmit;
